var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sub_view == 'rendimiento-general')?_c('div',[_c('h2',{staticClass:"m-t-15"},[_vm._v(" Periodo desde un año atras ")]),_c('total-vendido-y-rentabilidad'),_c('rentabilidad'),_c('acreedores')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }